<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" >
        <q-input v-model="inputValue"
                 :name="path"
                 :clearable="clearable"
                 :float-label="processedLabel"
                 :type="type"
                 :color="color"
                 :min-rows="minRows"
                 :disable="form.busy || disable"
                 :autofocus="focus ? true : false"
                 :hide-underline="hideUnderline"
                 :prefix="prefix"
                 @input="onInput"
                 :before="before"
                 :after="after"
                 @blur="event => $emit('blur', event)"></q-input>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QInput} from 'quasar-framework'

    export default {
        name: 'VInput',

        mixins,

        props: {
            type: {
                type: String,
                default: 'text'
            },
            minRows: {
                type: Number,
                default: 1
            },
            autofocus: Boolean,
            prefix: String,
            color: String
        },

        data() {
            return {
                inputValue: this.value || '',
                focus: false,
            }
        },

        watch:{
            inputValue(){
                if(this.inputValue !== null || this.inputValue !== ''){
                    this.focus = true
                }
            }
        },

        components: {
            QInput
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VInput.vue